// src/components/lead/sections/help/TrainingHelp.tsx

export function TrainingHelp() {
  return (
    <div className="text-sm text-blue-900 space-y-4 text-left">
      <div>
        <p className="font-semibold text-blue-950 mb-1.5">Roleplay</p>
        <ul className="list-disc list-inside space-y-1">
          <li>
            Open the <strong>Roleplay</strong> tab, choose a <strong>scenario</strong>, then <strong>Start roleplay</strong>.
          </li>
          <li>The AI plays the <strong>customer</strong>; you reply as the salesperson. Keep exchanging until the conversation feels complete.</li>
          <li>
            Tap <strong>End &amp; score</strong> for feedback (clarity, KB accuracy, answering the customer, follow-ups, open-ended questions, handling concerns) and a short summary.
            Sessions are saved for your progress strip when you score.
          </li>
          <li>
            The customer uses the same <strong>knowledge-base search</strong> as Ask &amp; policies, so grounded answers improve when org content is up to date.
          </li>
          <li>
            When <strong>voice</strong> is on and the speak mode includes <strong>answers</strong> (same as reading KB answers aloud), the customer&apos;s lines are read aloud too. Use <strong>Spoken reply</strong> to dictate your side of the conversation.
          </li>
          <li>
            Use <strong>New session</strong> to reset; use <strong>Ask &amp; policies</strong> for quick KB lookups without roleplay.
          </li>
          <li>
            If you have a <strong>Reviews</strong> tab, you can human-grade completed roleplays (AI + trainee) to build a review history for coaching and future prompt/KB improvements.
          </li>
        </ul>
      </div>
      <div>
        <p className="font-semibold text-blue-950 mb-1.5">Ask &amp; policies</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Ask questions about products, process, and policy.</li>
          <li>Buddy will answer and cite the top sources.</li>
          <li>
            Answers use the <strong>active workspace organization</strong>. Your org’s private articles (org scope) appear only for that org; manufacturer- and app-scoped published articles are shared across eligible orgs — not filtered by a manufacturer “subscription” row.
          </li>
          <li>Use the mode selector to return to Leads.</li>
        </ul>
      </div>
      <div>
        <p className="font-semibold text-blue-950 mb-1.5">Contacts</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Open the <strong>Contacts</strong> tab for a full scoped directory view (not just inline answer cards).</li>
          <li>Use search plus filters (scope, source, location) to narrow who should handle a workflow lane.</li>
          <li>
            The list combines <strong>app-user contacts</strong> and <strong>external contacts</strong> using the same visibility and path rules.
          </li>
          <li>
            Some rows may hide direct details and show chain-of-command guidance only; that is expected when trust/visibility policy limits direct access.
          </li>
        </ul>
      </div>
    </div>
  );
}
